import http from '../const/http-common'

const getTables = () => {
  return http.get('/v1/user/sql-geneartor/tables');
}

const getForeignTables = () => {
  return http.get('/v1/user/sql-geneartor/foreign-tables');
}

const TableService = {
  getTables,
  getForeignTables
}

export default TableService;